import { AIChatAttachment } from '@atom/types/ai';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';

import classes from './chat.module.css';

type ChatUserMessageAttachmentsProps = {
  attachments: AIChatAttachment[];
};

const ChatUserMessageAttachments = ({
  attachments,
}: ChatUserMessageAttachmentsProps) => {
  if (!attachments?.length) {
    return null;
  }

  return (
    <div className={classes.userMessageAttachments}>
      {attachments.map(attachment => (
        <div
          key={attachment.mediaId}
          className={classes.userMessageThumbnail}
          style={{
            backgroundImage: `url('${FILES_ENDPOINT}/${attachment.fileId}_180')`,
          }}
        />
      ))}
    </div>
  );
};

export default ChatUserMessageAttachments;
